import axios from "axios";

// REACT_APP_API_URL is set at build time (see .env.example). Falls back to a
// same-origin /api path, which works when the backend is reverse-proxied
// under the same domain as the frontend.
export const API = axios.create({
    baseURL: process.env.REACT_APP_API_URL || '/api',
    headers: {
        Accept: 'application/json',
        "Content-Type": 'application/json'
    }
})